import React, { Component } from 'react';
import classnames from 'classnames';
import { WithStyles, withStyles } from '@mui/styles';

import APStepTrackerStyles from './styles/APStepTracker.style';

interface APStepProps extends WithStyles<typeof APStepTrackerStyles> {
  children: Array<any>,
  className?: string
}

class APStepTracker extends Component<APStepProps, {}> {
  render() {
    const {
      className,
      classes,
      children
    } = this.props;

    const containerCls = classnames(classes.stepContainer, className);

    return (
      <div className={containerCls}>
        {children.map( (child, index) => (
          <div key={`stepTracker-${index}`} className={classes.stepWrapper}>
            {child}
          </div>
        ))}
      </div>
    );
  }
}

export default withStyles(APStepTrackerStyles)(APStepTracker);
